module.exports = __webpack_public_path__ + "img/fаlag-ger.5a390b92.svg";